<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="stat-content" :class="cn('flex min-h-6 max-w-full min-w-0 items-center gap-1', props.class)">
    <slot />
  </div>
</template>
